import React, { Component } from 'react';
import autobind from 'class-autobind';

import defer from 'lodash/defer';
import debounce from 'lodash/debounce';

import {
  MOBILE_BREAKPOINT_WIDTH 
} from 'zoomforth_codesbane_viewer/lib/browser_sizing.js';

import SiteViewerVersionComponentSelector
  from 'zoomforth_codesbane_viewer/component_lib/site_viewer_version_component_selector_container.jsx';

export const SECTION_WIDTH_CHANGE_EVENT = 'section_width_change';
export const SECTION_FONTSIZE_CHANGE_EVENT = 'section_fontsize_change';
export const ZOOM_MODE_ENABLED_EVENT = 'zoom_mode_enabled_event';
export const ZOOM_MODE_DISABLED_EVENT = 'zoom_mode_disabled_event';


const getDPR = ()=> (
  window.devicePixelRatio ||
  window.screen.deviceXDPI / window.screen.logicalXDPI
);

// resize events can occur from:
// - zoom events
// - resizing the width, height, or both
// - device orientation changing
class SubpageResizeEventManager_Base extends Component {

  constructor() {
    super();

    autobind(this);

    // set the default device pixel ratio value so we can determine if the
    // resize event should fire post resize events
    this.defaultDPR = getDPR();
  }

  // this component should never update so the children do not rerender
  shouldComponentUpdate() {
    return false;
  }

  componentWillUnmount() {
    $(window).off('resize.subpage_resize_event_manager');
  }

  didResizeOccurFromHeightChange() {
    const windowWidth = $(window).width();

    if(windowWidth === this.preResizeWindowWidth) {
      return true;
    }

    this.preResizeWindowWidth = $(window).width();

    return false;
  }

  didResizeOccurFromZoom(postResizeDPR) {
    // check if we are potentially looking at a zoom event. if the DPR values
    // before and after the resize do not match then this is a good
    // indication that they zoomed.
    //
    // in the case of a zoom we do not want to resize the actual content in
    // the page. to make that determination we check the postResizeDPR against
    // the defaultDPR to and if they don't match then they surely zoomed in.
    // this is important because if the user changed their mobile orientation
    // between portrait and landscape the defaultDPR and postResizeDPR will
    // still match and therefore allow content to rerender.
    if (this.preResizeDPR !== postResizeDPR) {
      this.preResizeDPR = postResizeDPR;

      if (postResizeDPR !== this.defaultDPR) {
        $(window).trigger(ZOOM_MODE_ENABLED_EVENT);
        return true;
      }

      $(window).trigger(ZOOM_MODE_DISABLED_EVENT);
    }

    return false;
  }

  render() {
    return this.props.children;
  }

}


class SubpageResizeEventManager_ViewerVersion1 extends SubpageResizeEventManager_Base {

  componentDidMount() {
    $(window).on('resize.subpage_resize_event_manager', debounce(()=> {

      if (this.didResizeOccurFromHeightChange()) {
        return;
      }

      if (this.didResizeOccurFromZoom(getDPR())) {
        return;
      }

      $(window).trigger(SECTION_WIDTH_CHANGE_EVENT);

      // we defer this so we can ensure that the width of the section has been
      // updated. this is because font size is determined by the section width.
      defer(() => {
        $(window).trigger(SECTION_FONTSIZE_CHANGE_EVENT);
      });

    }, 250));
  }

}

class SubpageResizeEventManager_ViewerVersion2 extends SubpageResizeEventManager_Base {

  componentDidMount() {
    $(window).on('resize.subpage_resize_event_manager', debounce(()=> {
      const windowWidth = $(window).width();

      if (this.didResizeOccurFromHeightChange()) {
        return;
      }

      // this is a cop-out to true responsive design
      this.props.onShouldRenderAsMobileChange(windowWidth <= MOBILE_BREAKPOINT_WIDTH);

      // we want zooming to be a viable reason to update the section width
      // unlike previous viewer versions
      $(window).trigger(SECTION_WIDTH_CHANGE_EVENT);

      if (this.didResizeOccurFromZoom(getDPR())) {
        return;
      }

      // we defer this so we can ensure that the width of the section has been
      // updated. this is because font size is determined by the section width.
      //
      // we still want this to happen if the resize wasn't zoom or height
      // related since zooming implies the font size should get bigger...not
      // rescale to fit the current screen
      defer(() => {
        $(window).trigger(SECTION_FONTSIZE_CHANGE_EVENT);
      });

    }, 250));
  }

}

const SubpageResizeEventManager = (props)=> (
  <SiteViewerVersionComponentSelector>
    <SubpageResizeEventManager_ViewerVersion1 forSiteViewerVersion={1} { ...props } />
    <SubpageResizeEventManager_ViewerVersion2 forSiteViewerVersion={2} { ...props } />
  </SiteViewerVersionComponentSelector>
);

export default SubpageResizeEventManager;
